import React, { useEffect } from 'react';
import { useClipboard } from '../../hooks/useClipboard';
import { InputSubmit } from '../common/InputSubmit';

export const CopyInputTimout = 4000;

export const CopyInput: React.FunctionComponent<{
  text: string;
  readOnly?: boolean;
  placeholder?: string;
}> = ({ text, readOnly, placeholder }) => {
  const { copyText, status, reset } = useClipboard({
    successMessage: 'Copied!',
    errorMessage: 'Failed to copy',
  });

  useEffect(() => {
    if (status !== 'success') {
      return;
    }
    const timeout = setTimeout(reset, CopyInputTimout);

    return () => clearTimeout(timeout);
  }, [status, reset]);

  return (
    <InputSubmit
      value={text}
      inputPlaceholder={placeholder}
      readOnly={readOnly}
      buttonText={'Copy'}
      onClick={() => copyText(text)}
    />
  );
};
